import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { loadConversationStarters } from './conversation-starters.effects';
import {
  ConversationStartersNamespace,
  ConversationStartersReducer,
} from './conversation-starters.state';

const effects = { loadConversationStarters };

export const provideConversationStartersEffects = provideEffects(effects);

export const provideConversationStartersState = provideState(
  ConversationStartersNamespace,
  ConversationStartersReducer,
);

export const provideConversationStartersNgrx = [
  provideConversationStartersEffects,
  provideConversationStartersState,
];

@NgModule({
  imports: [
    StoreModule.forFeature(ConversationStartersNamespace, ConversationStartersReducer),
    EffectsModule.forFeature(effects),
  ],
})
export class ConversationStartersStoreModule {}
